import React from 'react';
import { FormattedMessage } from 'react-intl';

import HotkeySectionLineItem from './line-item';

import { messages as gotoAccountMessages, hotkey as gotoAccountHotkey } from '../advanced-hotkeys/goto-account-settings';
import { messages as gotoCarrierMessages, hotkey as gotoCarrierHotkey } from '../advanced-hotkeys/goto-carrier-fulfullment-settings';
import { messages as gotoCustomersMessages, hotkey as gotoCustomersHotkey } from '../advanced-hotkeys/goto-customers';
import { messages as gotoOrdersMessages, hotkey as gotoOrdersHotkey } from '../advanced-hotkeys/goto-orders';
import { messages as gotoPrintMessages, hotkey as gotoPrintHotkey } from '../advanced-hotkeys/goto-print-setup-settings';
import { messages as gotoProductsMessages, hotkey as gotoProductsHotkey } from '../advanced-hotkeys/goto-products-inventory';
import { messages as gotoProductsInventoryMessages, hotkey as gotoProductsInventoryHotkey } from '../advanced-hotkeys/goto-products';
import { messages as gotoShipmentsBatchesMessages, hotkey as gotoShipmentsBatchesHotkey } from '../advanced-hotkeys/goto-shipments-batches';
import { messages as gotoShipmentsEodMessages, hotkey as gotoShipmentsEodHotkey } from '../advanced-hotkeys/goto-shipments-eod';
import {
  messages as gotoShipmentsFulfillmentsMessages,
  hotkey as gotoShipmentsFulfillmentsHotkey,
} from '../advanced-hotkeys/goto-shipments-fulfillments';
import { messages as gotoShipmentsPickupMessages, hotkey as gotoShipmentsPickupHotkey } from '../advanced-hotkeys/goto-shipments-pickup';
import { messages as gotoShipmentsReturnsMessages, hotkey as gotoShipmentsReturnsHotkey } from '../advanced-hotkeys/goto-shipments-returns';
import { messages as gotoShipmentsShipmentsMessages, hotkey as gotoShipmentsShipmentsHotkey } from '../advanced-hotkeys/goto-shipments';
import {
  messages as gotoShipstationMessages,
  hotkey as gotoShipstationHotkey,
} from '../advanced-hotkeys/goto-shipstation-connect-settings';
import { messages as gotoStoreMessages, hotkey as gotoStoreHotkey } from '../advanced-hotkeys/goto-store-setup-settings';
import { messages as gotoSubscriptionMessages, hotkey as gotoSubscriptionHotkey } from '../advanced-hotkeys/goto-subscription-settings';

const NavigationHotkeys = () => {
  return (
    <>
      <HotkeySectionLineItem hotkey={gotoAccountHotkey} name={<FormattedMessage {...gotoAccountMessages.name} />} />
      <HotkeySectionLineItem hotkey={gotoCarrierHotkey} name={<FormattedMessage {...gotoCarrierMessages.name} />} />
      <HotkeySectionLineItem hotkey={gotoCustomersHotkey} name={<FormattedMessage {...gotoCustomersMessages.name} />} />
      <HotkeySectionLineItem hotkey={gotoOrdersHotkey} name={<FormattedMessage {...gotoOrdersMessages.name} />} />
      <HotkeySectionLineItem hotkey={gotoPrintHotkey} name={<FormattedMessage {...gotoPrintMessages.name} />} />
      <HotkeySectionLineItem hotkey={gotoProductsHotkey} name={<FormattedMessage {...gotoProductsMessages.name} />} />
      <HotkeySectionLineItem hotkey={gotoProductsInventoryHotkey} name={<FormattedMessage {...gotoProductsInventoryMessages.name} />} />
      <HotkeySectionLineItem hotkey={gotoShipmentsBatchesHotkey} name={<FormattedMessage {...gotoShipmentsBatchesMessages.name} />} />
      <HotkeySectionLineItem hotkey={gotoShipmentsEodHotkey} name={<FormattedMessage {...gotoShipmentsEodMessages.name} />} />
      <HotkeySectionLineItem
        hotkey={gotoShipmentsFulfillmentsHotkey}
        name={<FormattedMessage {...gotoShipmentsFulfillmentsMessages.name} />}
      />
      <HotkeySectionLineItem hotkey={gotoShipmentsPickupHotkey} name={<FormattedMessage {...gotoShipmentsPickupMessages.name} />} />
      <HotkeySectionLineItem hotkey={gotoShipmentsReturnsHotkey} name={<FormattedMessage {...gotoShipmentsReturnsMessages.name} />} />
      <HotkeySectionLineItem hotkey={gotoShipmentsShipmentsHotkey} name={<FormattedMessage {...gotoShipmentsShipmentsMessages.name} />} />
      <HotkeySectionLineItem hotkey={gotoShipstationHotkey} name={<FormattedMessage {...gotoShipstationMessages.name} />} />
      <HotkeySectionLineItem hotkey={gotoStoreHotkey} name={<FormattedMessage {...gotoStoreMessages.name} />} />
      <HotkeySectionLineItem hotkey={gotoSubscriptionHotkey} name={<FormattedMessage {...gotoSubscriptionMessages.name} />} />
    </>
  );
};

export default NavigationHotkeys;
